// extracted by mini-css-extract-plugin
module.exports = {"txtimgbg_hero":"index-module__txtimgbg_hero___iSON2"};